import { render, staticRenderFns } from "./PartnerEditPage.vue?vue&type=template&id=57da27f2&"
import script from "./PartnerEditPage.vue?vue&type=script&lang=ts&"
export * from "./PartnerEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports